'use client'
import { useRef } from 'react'
import { Provider } from 'react-redux'
import { makeStore, AppStore } from '@/lib/client/store'
import { CartInfo, SessionInfo, WishlistInfo } from '@/types'
import { loginSuccess } from '@/lib/client/sessionSlice'
import { loadCart } from '@/lib/client/cartSlice'
import { loadWishlist } from '@/lib/client/wishlistSlice'

export default function StoreProvider({
  children,
  userAndSessionInfo,
  cart,
  wishlist,
}: {
  children: React.ReactNode,
  userAndSessionInfo?: SessionInfo,
  cart?: CartInfo,
  wishlist?: WishlistInfo,
}) {
  const storeRef = useRef<AppStore | null>(null)
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore()
    if (userAndSessionInfo) {
      storeRef.current.dispatch(loginSuccess(userAndSessionInfo));
    }
    if (cart) {
      storeRef.current.dispatch(loadCart(cart));
    }
    if (wishlist) {
      storeRef.current.dispatch(loadWishlist(wishlist));
    }
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}
